import { InventoryCount } from 'types/inventory';
import { transformUTCStringToLocalDate } from 'utils/dateUtils';
import * as yup from 'yup';
import { EditInventoryCountFormikProps } from './EditInventoryCountModal.props';

export const getInitialValues = (
  count: InventoryCount | null,
): EditInventoryCountFormikProps => ({
  site: count?.site || '',
  countDate: count?.countDate
    ? transformUTCStringToLocalDate(count?.countDate)
    : new Date().toISOString(),
  openItems: count?.openItems || [],
  openCases: count?.openCases || [],
  sealedPackages: count?.sealedPackages || [],
  notes: count?.notes || '',
  archive: count?.isArchived || false,
});

export const validationSchema = yup.object().shape({
  site: yup.string().required('Site is required'),
  countDate: yup.date().required('Count date is required'),
});
